import React, { useState, useContext } from "react";
import styles from "./style.module.scss";
import dayjs from "dayjs";

import "dayjs/locale/ru";
import getDays from "../../../helpers/getDays";

// import { useTelegram } from "../../../components/hooks/useTelegram";

import { setDataService } from "../../../controllers/APIDataCallController/APIDataCallController";
import { MainContext } from "../../../context/MainContext";

import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import FormHelperText from "@mui/material/FormHelperText";

import { PenOff, PencilLine } from "lucide-react";

function DisplayAddService() {
  const currentDate = new Date();
  const { setOpenModal, selectedMarker, setSelectedMarker, setMarkers, setArchive, user } = useContext(MainContext);
  const [valueDatePicker, setValueDatePicker] = useState(dayjs(currentDate));
  const [loading, setLoading] = useState(false);

  const handleSetData = async () => {
    setLoading(true);
    await setDataService(
      user,
      valueDatePicker,
      selectedMarker,
      setOpenModal,
      setSelectedMarker,
      setMarkers,
      setArchive,
    );
    setLoading(false);
  };

  const setHandleClose = () => {
    setOpenModal(false);
    setSelectedMarker(null);
  };

  return (
    <>
      {loading && (
        <div className={styles.loader}>
          <Box sx={{ display: "flex", marginRight: "20px" }}>
            <CircularProgress color="basic" size={40} />
          </Box>
        </div>
      )}
      <div className={styles.modal__wrapper}>
        <div className={styles.modal__title_container}>
          <h2 className={styles.modal__title}>Добавить Техническое обслуживание</h2>
        </div>
        <div className={styles.modal__container}>
          <LocalizationProvider adapterLocale="ru" dateAdapter={AdapterDayjs}>
            <DemoContainer components={["MobileDatePicker"]}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  padding: "10px",
                }}
              >
                <Typography
                  sx={{
                    marginBottom: "10px",
                    paddingLeft: "12px",
                    fontSize: 14,
                    fontFamily: "Montserrat, serif",
                    color: "#fff",
                  }}
                >
                  Выбери дату проведения ТО
                </Typography>
                <MobileDatePicker
                  value={valueDatePicker}
                  maxDate={dayjs(currentDate)}
                  onChange={(newValue) => setValueDatePicker(newValue)}
                  slotProps={{
                    textField: {
                      helperText: (
                        <FormHelperText
                          sx={{
                            margin: 0,
                            fontSize: 14,
                            fontFamily: "Montserrat, serif",
                            color: "#fff",
                          }}
                        >
                          {getDays(valueDatePicker)}
                        </FormHelperText>
                      ),
                    },
                  }}
                />
              </Box>
            </DemoContainer>
          </LocalizationProvider>
        </div>
        <div className={styles.modal__button_container}>
          <button className={styles.modal__button_change} onClick={() => handleSetData()}>
            <PencilLine color="#ff0e00" size={20} />
            Добавить
          </button>
          <button className={styles.modal__button_close} onClick={() => setHandleClose()}>
            <PenOff color="#ff0e00" size={20} />
            Отменить
          </button>
        </div>
        {/* <Button variant="outlined" className={styles.button} onClick={}>
          Добавить
        </Button> */}
      </div>
    </>
  );
}

export default DisplayAddService;
